<template>
  <basic-dialog @close="$emit('close')" :show="show">
    <template v-slot:title>{{ title }}</template>
    <v-tabs
      background-color="deep-purple accent-4"
      center-active
      dark
      v-model="tab"
    >
      <v-tab key="details">Details</v-tab>
      <v-tab key="users">Users Management</v-tab>
      <v-tabs-items v-model="tab">
        <v-tab-item key="details">
          <v-row
            ><v-col class="pb-0"
              ><v-text-field
                label="Name"
                v-model="name"
                :outlined="outlinedInputs"
                hide-details /></v-col
          ></v-row>
          <access-settings-editor
            v-model="accessSettings"
            :key="value ? value.id : `1`"
          />
        </v-tab-item>
        <v-tab-item key="users">
          <users-management v-model="users" :accessGroupId="value.id" />
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>
    <template v-slot:actions>
      <v-btn color="primary" @click="onSave" :disabled="!isValid">Save</v-btn>
    </template>
    <div v-if="debug">
      <code>{{ users }}</code>
    </div>
  </basic-dialog>
</template>

<script>
import AccessSettingsEditor from "../../agents/AccessSettingsEditor.vue";
import BasicDialog from "../../shared/BasicDialog.vue";
import UsersManagement from "./UsersManagement.vue";
export default {
  name: "access-group-dialog",
  props: {
    show: {
      type: Boolean,
      default: () => false,
    },
    value: {
      type: Object,
      default: () => false,
    },
  },

  components: { BasicDialog, AccessSettingsEditor, UsersManagement },

  data() {
    return {
      debug: false,
      tab: null,
      name: this.value ? this.value.name : "New Access Group",
      accessSettings: this.value ? this.value.accessSettings : [],
      users: this.value && this.value.users ? this.value.users : [],
    };
  },

  computed: {
    title() {
      return this.name;
    },
    isValid() {
      return this.name != "";
    },
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
  },

  watch: {
    value(newVal) {
      this.name = newVal.name;
      this.accessSettings = [...newVal.accessSettings];
      this.users = newVal.users ? [...newVal.users] : [];
    },
  },

  methods: {
    onSave() {
      this.$emit("save", {
        id: this.value.id,
        name: this.name,
        accessSettings: this.accessSettings.map((item) => ({
          groupName: item.groupName,
          settingName: item.settingName,
          settingValue: item.settingValue,
        })),
      });
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/admin/user-access-controls/AccessGroupDialog.vue